<template>
  <div class="tile">
    <h6>Tìm thông tin người dùng của Client từ email</h6>
    <div class="row">
      <div class="col-8">
        <form-input :model="filterFormModel" attribute="email" placeholder="Email cần tìm"></form-input>
      </div>
      <div class="col-4">
        <button :disabled="!filterFormModel.email" @click="load" class="btn btn-primary ml-2">
          {{ $t("search") }}
        </button>
      </div>
    </div>
    <b-modal v-model="showForm" :title="$t('infoClient')" @ok="save" hide-footer>
      <div>
        <p>
          <b>{{ $t("companyName") }}: </b><span>{{ formModel.companyName }}</span>
        </p>
        <p>
          <b>{{ $t("phone") }}: </b><span>{{ formModel.phone }}</span>
        </p>
        <p>
          <b>{{ $t("email") }}: </b><span>{{ formModel.email }}</span>
        </p>
        <p v-if="formModel.taxCode">
          <b>{{ $t("taxCode") }}: </b><span>{{ formModel.taxCode }}</span>
        </p>
        <p v-else>
          <b>{{ $t("taxCode") }}: </b><span>{{ $t('notUpdated') }}</span>
        </p>
        <p>
          <b><span>{{ $t("status") }}: </span></b>
          <span v-if="formModel.active" class="mr-1 badge badge-primary">{{
            $t("active")
          }}</span>
          <span v-if="!formModel.active" class="badge badge-danger">{{ $t('Expired') }}</span>
          <span v-if="formModel.isDemo" class="mr-1 badge badge-info">
            {{ $t("demo") }}</span>
          <span v-if="formModel.isTrial" class="mr-1 badge badge-warning">{{
            $t("isTrial")
          }}</span>
        </p>
        <p>
          <b>{{ $t("numberOfUser") }}: </b><span>{{ formModel.userLimit }}</span>
        </p>
        <p>
          <b>{{ $t("creditBalance") }}: </b><span>{{ formModel.creditBalance }}đ</span>
        </p>
        <p>
          <b>{{ $t("sales") }}: </b><span v-if="formModel.sales">{{ formModel.sales.name }}</span><span v-else>{{
            $t("noSales") }}</span>
        </p>
        <p>
          <b>{{ $t("account") }}: </b><span v-if="formModel.account">{{ formModel.account.name }}</span><span v-else>{{
            $t("noAccount") }}</span>
        </p>
        <p>
          <b>{{ $t("domain") }}: </b>
          <span>{{ formModel.domain }}</span>
        </p>
        <p>
          <b>{{ $t("plan") }}: </b>
          <span v-if="formModel.privatePlan">{{ $t("privatePlan") }}</span>
          <span v-else-if="formModel.plan">{{ formModel.plan.name }}</span>
          <span v-else class="text-danger">{{ $t("na") }}</span>
        </p>
        <p>
          <b>{{ $t("userPrice") }}: </b>
          <span v-if="formModel.plan">{{ formModel.plan.userPrice }}đ</span>
        </p>
        <p>
          <b>{{ $t("createTime") }}: </b>
          <span v-if="formModel.plan">{{
            formModel.plan.createTime | moment("DD/MM/YY HH:mm:ss")
          }}</span>
        </p>
        <p>
          <b>{{ $t("updateTime") }}: </b>
          <span v-if="formModel.plan">{{
            formModel.plan.updateTime | moment("DD/MM/YY HH:mm:ss")
          }}</span>
        </p>
        <p>
          <b>{{ $t("expireTime") }}: </b>
          <span v-if="formModel.expireTime">{{
            formModel.expireTime | moment("DD/MM/YY HH:mm:ss")
          }}</span>
        </p>
        <p>
          <b>{{ $t("userPrice") }}: </b>
          <span v-if="formModel.plan">{{ formModel.plan.userPrice }}đ</span>
        </p>
      </div>
      <div>
        <h5>{{ $t("infoClientUser") }}</h5>
        <p>
          <b>{{ $t("name") }}: </b>
          <span v-if="userClient">{{ userClient.name }}</span>
        </p>
        <p>
          <b>{{ $t("phone") }}: </b>
          <span v-if="userClient">{{ userClient.phone }}</span>
        </p>
        <p>
          <b>{{ $t("role") }}: </b>
          <span v-if="userRole">{{ userRole }}</span>
        </p>
        <p>
          <b>{{ $t("ext") }}: </b>
          <span v-if="userClient">{{ userClient.ext }}</span>
        </p>
        <p>
          <b>{{ $t("extPassword") }}: </b>
          <span v-if="userClient">{{ userClient.extPassword }}</span>
        </p>
        <p>
          <b>{{ $t("email") }}: </b>
          <span v-if="userClient">{{ userClient.email }}</span>
        </p>
        <p>
          <b>{{ $t("lastOnlineTime") }}: </b>
          <span v-if="userClient">
            <span v-if="userClient.lastOnlineTime == 0">{{
              $t("notLoggedIn")
            }}</span>
            <span v-else>
              {{ userClient.lastOnlineTime | moment("DD/MM/YY HH:mm:ss") }}
            </span>
          </span>
        </p>
      </div>
    </b-modal>
  </div>
</template>
<script>
import List from "@/mixins/List";
import CRUD from "@/mixins/CRUD";

export default {
  mixins: [List, CRUD],
  data: function () {
    return {
      service: "/tool/email",
      autoLoad: false,
      defaultFilterFormModel: {
        email: null,
      },
      userRole: null,
      userClient: null,
    };
  },
  methods: {
    apply: function (data) {
      this.formModel = data.client;
      this.userClient = data.userClient;
      this.userRole = data.userRole;
      this.formTitle = "";
      this.showForm = true;
    },
  },
  i18n: {
    messages: {
      en: {
        active: 'Activating',
        notLoggedIn: 'Not logged in',
        lastOnlineTime: "Last login time",
        infoClient: "Client information",
        ext: "Extension",
        extPassword: "Extension password",
        searchEmail: "please search email",
        infoClientUser: "Client's user information",
        status: "status",
        host: "Host",
        domain: "Domain",
        companyName: "Company name",
        plan: "Plan",
        isTrial: 'Trial',
        chooseCountryFirst: "Choose a country first",
        choosePlan: "Choose a plan",
        expireTime: "Expired time",
        numberOfUser: "Number of user",
        userLimit: "User limit",
        numberLimit: "Number limit",
        userNumberLimit: "Smartphone limit",
        creditLimit: "Credit limit",
        storageLimit: "Storage size per user (GB)",
        addedStorage: "Added storage (GB)",
        totalStorage: "Total storage limit (GB)",
        numberOfNumber: "Number of number",
        numberOfSmartphone: "Number of smartphone",
        clientInfo: "Client info",
        subscribeInfo: "Subscribe info",
        pipelineEnabled: "Pipeline",
        multiChannelEnabled: "Multi-channel",
        eventEnabled: "Event",
        callCampaignEnabled: "Call campaign",
        kpiEnabled: "KPI",
        creditBalance: "Credit Balance",
        yes: "Yes",
        no: "No",
        createDeposit: "Create a deposit",
        na: "Not available",
        timezone: "Timezone",
        chooseTimezone: "Choose timezone",
        privatePlan: "Private plan",
        userPrice: "Price per user per month",
        expired: "Expired",
        activating: "Activating",
        locked: "Locked",
        createTime: "Create time",
        sales: "Sale person",
        noSales: "No pos person",
        account: "Account",
        noAccount: "No pos account",
        taxCode: "Tax code",
        notUpdated: "Not updated",
        source: "Source",
        agency: "Agency",
        chooseSource: "Choose source",
        chooseSales: "Choose sales",
        chooseAccount: "Choose account",
        baseCallFee: "Base call fee",
        monthlyUserPackage: "Monthly user package",
        allowMultipleLogins: "Allow multiple logins",
        allowDNC: "Allow DNC",
        care: "Care",
        careConfirm: "Are you sure to care this client?",
        careSuccess: "Care ,client successfully!",
        careFailed: "Fail to care client",
        trialExtendRequest: "Trial extend request",
        filterByUserCount: "All user count",
        activeUser: "Number of active user",
        userCountMin: "Min user count",
        userCountMax: "Max user count",
        mediaRelay: "Media relay",
      },
      vi: {
        active: 'Đang hoạt động',
        notLoggedIn: 'Chưa đăng nhập',
        lastOnlineTime: "Thời gian đăng nhập lần cuối",
        infoClient: "Thông tin của khách hàng",
        ext: "Số nhánh",
        extPassword: "mật khẩu số nhánh",
        infoClientUser: "Thông tin user của khách hàng",
        searchEmail: "Vui lòng nhập email",
        status: "Trạng thái",
        host: "Tổng đài",
        domain: "Domain",
        companyName: "Tên công ty",
        plan: "Gói dịch vụ",
        isTrial: 'Dùng thử',
        chooseCountryFirst: "Chọn quốc gia trước",
        choosePlan: "Chọn gói dịch vụ",
        expireTime: "Thời gian hết hạn",
        numberOfUser: "Số user",
        userLimit: "Giới hạn số user",
        numberLimit: "Giới hạn số đầu số",
        userNumberLimit: "Giới hạn số smartphone",
        creditLimit: "Hạn mức tài khoản tối thiểu",
        storageLimit: "Dung lượng lưu trữ / user (GB)",
        addedStorage: "Dung lượng mua thêm (GB)",
        totalStorage: "Tổng dung lượng lưu trữ (GB)",
        numberOfNumber: "Số đầu số",
        numberOfSmartphone: "Số smartphone",
        clientInfo: "Thông tin khách",
        subscribeInfo: "Thông tin gói cước",
        callCampaignEnabled: "Chiến dịch gọi điện",
        kpiEnabled: "KPI",
        creditBalance: "Số dư tài khoản",
        yes: "Có",
        no: "Không",
        na: "Không có",
        timezone: "Múi giờ",
        chooseTimezone: "Chọn múi giờ",
        privatePlan: "Gói cước riêng",
        userPrice: "Giá/user/tháng",
        expired: "Hết hạn",
        trial: "Đang dùng thử",
        trialExpiredSoon: "Dùng thử sắp hết hạn",
        trialExpired: "Dùng thử đã hết hạn",
        expiredSoon: "Sắp hết hạn",
        activating: "Đang hoạt động",
        locked: "Bị khoá",
        createTime: "Tạo lúc",
        sales: "Nhân viên sales",
        noSales: "Chưa có nhân viên sales",
        account: "Nhân viên account",
        noAccount: "Chưa có nhân viên account",
        taxCode: "Mã số thuế",
        notUpdated: "Chưa cập nhật",
        source: "Nguồn khách",
        agency: "Đại lý / CTV",
        chooseSource: "Chọn nguồn",
        chooseSales: "Chọn sales",
        chooseAccount: "Chọn account",
        baseCallFee: "Cước nền",
        monthlyUserPackage: "Trọn gói tháng",
        trialExtendRequest: "Yêu cầu gia hạn dùng thử",
        filterByUserCount: "Tất cả số lượng user",
        activeUser: "Số lượng user đang hoạt động",
      },
    },
  },
};
</script>
